import React from "react";
import ReactPlayer from "react-player";

function FounderVideoSection() {
  return (
    <div style={{ maxWidth: "800px", margin: "40px auto", padding: "0 20px" }}>
      <h2 style={{ textAlign: "center", fontSize: "2rem", marginBottom: "20px" }}>
        Founder Video
      </h2>
      <ReactPlayer 
        url="https://youtu.be/rlnrNPybtUM"
        controls
        width="100%"
      />
    </div>
  );
}

export default FounderVideoSection; 